<div [class.show]="show" class="loader-overlay step">
  <img class="logo-image" [src]="'assets/intro-logo.png'"
       alt="Cardea Commerce Loader">
</div>
